import { BaseEntity } from 'yt-ng-framework';
export class Mesto extends BaseEntity{
    constructor(){
        super();
    }

    PostBroj: string = null;
    Naziv: string = null;
    OpstinaID: number = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.PostBroj = input.PostBroj;
        this.Naziv = input.Naziv;
        this.OpstinaID = input.OpstinaID;
        return this;
    }

    Serialize(input: Mesto){
        return input;
    }
}